require('./ProgramPosts.scss');

const b = require('app/www/libs/b')('program-posts');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Global = require('app/www/components/blocks/Global/Global');
const Link = require('app/www/components/blocks/Link/Link');
const ProgramSubtitle = require('app/www/components/blocks/ProgramSubtitle/ProgramSubtitle');

const POSTS_COUNT = 3;

class ProgramPosts extends React.PureComponent {

    constructor(props) {
        super(props);

        const {posts} = this.props;
        this._posts = posts.slice(0, POSTS_COUNT);
    }

    render() {
        const {i18n, posts, programCoId} = this.props;

        const programSubtitleProps = {
            text: i18n.get('program-posts.title'),
            link: posts.length > POSTS_COUNT && {
                url: Global.kinopoiskPostsUrl(programCoId),
            },
        };

        const linkProps = {
            attrs: {
                target: '_blank',
            },
        };

        return (
            <div className={b()}>
                <div className={b('title')}>
                    <ProgramSubtitle {...programSubtitleProps} />
                </div>
                {this._posts.map(post => {
                    const url = Global.kinopoiskPostUrl(post.id);

                    const imageStyle = {
                        backgroundImage: `url('${post.image}')`,
                    };

                    return (
                        <Link
                            key={post.id}
                            className={b('link')}
                            url={url}
                            {...linkProps}
                        >
                            <span className={b('inner')}>
                                <span className={b('image')} style={imageStyle} />
                                <span className={b('text')}>
                                    <span className={b('name')}>{post.title}</span>
                                    <span className={b('date')}>{post.date}</span>
                                </span>
                            </span>
                        </Link>
                    );
                })}
            </div>
        );
    }
}

ProgramPosts.propTypes = {
    posts: PropTypes.arrayOf(PropTypes.object),
    programCoId: PropTypes.number,
};

module.exports = withI18n(ProgramPosts);
